<template>
  <div>
    <Card>
      <Row>
        <Button type="info" @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate
        :columns="columns"
        :data="categories"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
    <Modal v-model="modalShow" @on-ok="handleSubmit" :title="$t('pages_categories_index_240')">
      <Form ref="category" :model="category" :label-width="80">
        <Form-item :label="$t('pages_categories_index_241')" prop="name">
          <Input type="text" :placeholder="$t('pages_categories_index_242')" v-model="category.name" />
        </Form-item>
        <Form-item :label="$t('pages_categories_index_243')" prop="is_display">
          <i-switch size="large" v-model="category.is_display">
            <span slot="open">{{$t('libs_table_render_50')}}</span>
            <span slot="close">{{$t('directives_index_41')}}</span>
          </i-switch>
        </Form-item>
        <Form-item :label="$t('libs_table_render_86')" prop="image">
          <uploader @uploadedUrl="uploadedUrl" :url="category.image"></uploader>
        </Form-item>
      </Form>
    </Modal>
    <sync-data-shop ref="syncDataShop" @sync="syncToSubShop" />
    <sync-data-shops ref="syncDataShops" @sync="syncToSubShops" />
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import Uploader from '@/components/uploader-aliyun/single'
import { syncShopsButtonInTable, deleteButtonInTable, editorButtonInTable, tableAvatar } from '@/libs/table-render'
import SyncDataShop from '@/components/sync-data-shop/index'
import SyncDataShops from '@/components/sync-data-shop/multiple'

export default {
  components: {
    TablePaginate,
    Uploader,
    SyncDataShop,
    SyncDataShops
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_categories_index_241'),
          key: 'name'
        },
        {
          title: i18n.t('pages_ai_thirdparty_165'),
          key: 'image',
          align: 'center',
          render: (h, params) => {
            return tableAvatar(h, params.row.image)
          }
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 300,
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            if (localStorage.getItem('IS_CLONED_MAIN_SHOP') === '1') {
              // children.push(syncButtonInTable(this, h, params))
              children.push(syncShopsButtonInTable(this, h, params))
            }
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapGetters('category', ['category', 'categories', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('category', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy',
      'syncToSubShop',
      'syncToSubShops'
    ]),
    ...mapMutations('category', ['changeQuery', 'targetSyncId']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    uploadedUrl (url) {
      if (this.category.image) {
        this.category.image = url
      } else {
        this.$set(this.category, 'image', url)
      }
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.category)
      } else if (this.formType === 'new') {
        await this.create(this.category)
      }
      this.modalShow = false
    }
  }
}
</script>
